import { Injectable, inject } from '@angular/core';
import { AuthService } from '@feature/auth';
import { NavController } from '@ionic/angular';
import { UISnackbarService } from '@ui/components';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GraphqlService {
  private readonly authService: AuthService = inject(AuthService);
  private readonly snackbar: UISnackbarService = inject(UISnackbarService);
  private readonly navCtrl: NavController = inject(NavController);

  token$(): Observable<string | null> {
    return this.authService.getToken$();
  }

  refreshAfterUnauthorized$(): Observable<void> {
    return this.authService.refreshAfterUnauthorized$();
  }

  isSessionRejected(error: unknown): boolean {
    return this.authService.isSessionRejected(error);
  }

  logout(): void {
    if (!this.authService.isLoggedIn() || this.authService.isLoginPending()) {
      return;
    }
    this.snackbar.showNeutral('Your session has expired, please log in again');
    this.authService.logout();
    this.navCtrl.navigateForward(['/']);
  }
}
